import React, { Component } from 'react'
import styles from "./demoDevCatchmentData.module.css"
import Button from '../../../Button/button';
import ActionButton from '../../../Button/actionButton';
import { Light as SyntaxHighlighter } from 'react-syntax-highlighter';
import json from 'react-syntax-highlighter/dist/esm/languages/hljs/json';
import arta from 'react-syntax-highlighter/dist/esm/styles/hljs/arta';
import { injectIntl } from 'react-intl';
import { compose } from 'recompose';
SyntaxHighlighter.registerLanguage('json', json);

const isMobile = typeof window !== `undefined` && window.innerWidth <= 768;

class DemoDevCatchmentData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      y: '',
      x: '',
      geom: '',
      curl: 'curl -X POST "http://locit.eu/webservice/catchment-data/v2.2.0/" -H "accept: application/json" -H "Content-Type: application/x-www-form-urlencoded" -d "y=51.752614&x=18.080909&geom=SRID%3D3857%3BMULTIPOLYGON(((2011039.09945234%206754072.54043212%2C2011058.21300891%206754257.72495015%2C2011096.4289901%206754442.89571074%2C2011172.87208443%206754566.3632098%2C2011172.87208443%206754689.81460554%2C2011096.4289901%206754813.28585825%2C2011058.21300891%206754998.46928546%2C2011096.4289901%206755183.67491645%2C2011249.30404681%206755430.61633377%2C2011478.62219784%206755554.08086707%2C2011555.05416022%206755924.52169511%2C2011631.49725455%206756047.99373732%2C2011631.49725455%206756171.48564033%2C2011555.05416022%206756294.96143744%2C2011516.83817903%206756480.19663751%2C2011555.05416022%206756665.43606286%2C2011631.49725455%206756788.91937068%2C2011707.92921693%206757159.39854647%2C2011822.58829245%206757221.16170729%2C2011975.46334915%206757221.16170729%2C2012090.11129272%206757159.39854647%2C2012166.55438705%206757035.90960499%2C2012242.98634943%206757035.90960499%2C2012319.42944375%206757406.40004962%2C2012472.30450046%206757653.40906628%2C2012586.95244403%206757715.15799775%2C2012701.61151955%206757653.40906628%2C2012778.04348193%206757282.90735189%2C2013007.36163296%206757159.39854647%2C2013083.79359534%206757035.90960499%2C2013160.23668967%206757035.90960499%2C2013236.66865204%206757159.39854647%2C2013351.32772756%206757221.16170729%2C2013809.94176573%206757221.16170729%2C2013924.60084125%206757159.39854647%2C2014001.04393558%206757035.90960499%2C2014230.35095466%206756912.40455621%2C2014268.56693585%206756727.17748206%2C2014268.56693585%206756480.19663751%2C2014306.78291704%206756294.96143744%2C2014459.65797375%206756047.99373732%2C2014536.10106807%206756047.99373732%2C2014612.53303045%206756171.48564033%2C2014688.97612478%206756171.48564033%2C2014765.40808716%206755801.0335474%2C2014841.85118149%206755801.0335474%2C2014918.28314387%206755924.52169511%2C2015147.59016295%206756047.99373732%2C2015682.6584274%206756912.40455621%2C2015797.30637097%206756974.16583845%2C2015911.96544648%206756912.40455621%2C2015950.18142767%206756727.17748206%2C2015911.96544648%206756541.93664836%2C2015453.34027636%206755801.0335474%2C2015224.03325728%206755677.56525979%2C2015147.59016295%206755554.08086707%2C2014918.28314387%206755430.61633377%2C2014918.28314387%206755307.15367736%2C2014994.72623819%206755183.67491645%2C2015032.94221938%206754998.46928546%2C2015032.94221938%206754751.55898745%2C2014994.72623819%206754566.3632098%2C2014918.28314387%206754566.3632098%2C2014841.85118149%206754689.81460554%2C2014727.19210597%206754751.55898745%2C2014612.53303045%206754689.81460554%2C2014574.31704926%206754504.63821557%2C2014574.31704926%206753517.03018666%2C2014536.10106807%206753331.8625547%2C2014459.65797375%206753331.8625547%2C2014383.22601137%206753702.20203986%2C2014153.91899228%206754072.54043212%2C2014115.69187914%206754257.72495015%2C2014115.69187914%206754504.63821557%2C2014077.47589795%206754689.81460554%2C2014001.04393558%206754689.81460554%2C2013924.60084125%206754566.3632098%2C2013695.29382216%206754442.89571074%2C2013542.41876546%206754195.98432225%2C2013542.41876546%206754072.54043212%2C2013618.85072784%206753949.09841807%2C2013695.29382216%206753578.7476761%2C2013848.16887887%206753331.8625547%2C2013962.81682244%206753270.14694109%2C2014115.69187914%206753270.14694109%2C2014230.35095466%206753208.43179639%2C2014230.35095466%206753084.98493693%2C2014115.69187914%206753023.271199%2C2013504.20278427%206753023.271199%2C2013389.54370875%206753084.98493693%2C2013313.11174637%206753208.43179639%2C2013198.45267085%206753270.14694109%2C2013083.79359534%206753208.43179639%2C2013007.36163296%206752838.11482218%2C2012892.70255744%206752776.40295977%2C2012586.95244403%206752776.40295977%2C2012472.30450046%206752838.11482218%2C2012242.98634943%206753208.43179639%2C2012128.32727391%206753270.14694109%2C2011975.46334915%206753270.14694109%2C2011860.80427364%206753331.8625547%2C2011784.36117931%206753702.20203986%2C2011631.49725455%206753949.09841807%2C2011516.83817903%206754010.81919059%2C2011402.17910352%206753949.09841807%2C2011325.74714114%206753825.6403017%2C2011211.08806562%206753763.92093629%2C2011058.21300891%206753763.92093629%2C2010943.5539334%206753825.6403017%2C2010924.45150878%206753949.09841807%2C2011039.09945234%206754072.54043212)))&format=json&charset=UTF-8"',
      code: {
        "info": {
          "code": 200,
          "message": "OK response. Server understood request and returned correct response",
          "machine": "prod1",
          "version": "v2.2.0"
        },
        "data": {
          "voiv": "WIELKOPOLSKIE",
          "pov": "KALISZ",
          "mun": "KALISZ",
          "mun_type": "GMINA MIEJSKA",
          "msegm": "B1",
          "mwg7": "3061011",
          "mwg7d": "3061011",
          "ctype": "MIASTO",
          "area_km2": "5.0034",
          "bld_t": "3276",
          "bld_r": "2255",
          "apts_r": "16433",
          "apts_rp": "15126",
          "pop_tot": "38545",
          "hh_size": "2.55",
          "pop_den": "7704",
          "pop_ax_t": "44.3",
          "pprf": "54.15",
          "pprm": "45.85",
          "ppr0004": "4.13",
          "ppr0509": "4.49",
          "ppr1014": "4.08",
          "ppr1519": "4.26",
          "ppr2024": "4.89",
          "ppr2529": "5.81",
          "ppr3034": "7.21",
          "ppr3539": "7.70",
          "ppr4044": "7.20",
          "ppr4549": "6.07",
          "ppr5054": "5.60",
          "ppr5559": "6.47",
          "ppr6064": "8.37",
          "ppr6569": "7.49",
          "ppr7074": "5.50",
          "ppr7599": "10.72",
          "inbld_t": "3526",
          "poc_tot": "2032",
          "crc_tot": "536",
          "workers": "11654",
          "iahu_x": "129",
          "iahu_p": "104",
          "poi_tot": "547",
          "poi_atm": "33",
          "poi_bank": "36",
          "poi_mall": "2",
          "poi_edut": "75",
          "poi_eduk": "16",
          "poi_edup": "11",
          "poi_edus": "13",
          "poi_eduh": "4",
          "poi_ret": "72",
          "poi_rcon": "18",
          "poi_rdro": "7",
          "poi_rdys": "5",
          "poi_rhip": "1",
          "poi_rsup": "3",
          "poi_haz": "34",
          "poi_hor": "20",
          "poi_cul": "6",
          "poi_poo": "7",
          "poi_enc": "7",
          "poi_gst": "2",
          "poi_trst": "1",
          "poi_trt": "84",
          "poi_tsto": "73",
          "poi_ps": "4",
          "poi_hea": "155",
          "poi_heap": "25",
          "alc_t": "138",
          "alc_r": "82",
          "alc_h": "56",
          "pod_atm": "166",
          "pod_bank": "153",
          "pod_mall": "386",
          "pod_edut": "134",
          "pod_eduk": "134",
          "pod_edup": "309",
          "pod_edus": "280",
          "pod_eduh": "579",
          "pod_rt": "42",
          "pod_rcon": "42",
          "pod_rdro": "255",
          "pod_rdys": "234",
          "pod_rhip": "1178",
          "pod_rsup": "330",
          "pod_haz": "151",
          "pod_hor": "65",
          "pod_cul": "463",
          "pod_poo": "153",
          "pod_enc": "139",
          "pod_gst": "494",
          "pod_trt": "180",
          "pod_trst": "1133",
          "pod_tsto": "-1",
          "pod_ps": "509",
          "pod_hea": "109",
          "pod_heap": "109",
          "pbne_rb": "6.11",
          "pbne_rd": "0.27",
          "pbne_rc": "41.33",
          "pbne_fs": "0.00",
          "pbne_rts": "27.41",
          "pbne_rf": "11.23",
          "pbne_rur": "0.00",
          "plau_for": "0",
          "plau_aip": "0",
          "plau_inc": "4.58",
          "plau_prz": "0",
          "plau_agr": "4.98",
          "plau_spo": "0.80",
          "plau_ror": "0.40",
          "plau_wat": "0",
          "plau_cbd": "78.88",
          "plau_cbc": "10.36",
          "mhh_size": "2.75",
          "mpop_den": "1404",
          "mpop_axt": "42.9",
          "mpprf": "53.81",
          "mpprm": "46.19",
          "mppr0004": "4.30",
          "mppr0509": "4.92",
          "mppr1014": "4.49",
          "mppr1519": "4.55",
          "mppr2024": "5.22",
          "mppr2529": "6.06",
          "mppr3034": "7.22",
          "mppr3539": "7.69",
          "mppr4044": "7.61",
          "mppr4549": "6.47",
          "mppr5054": "5.92",
          "mppr5559": "6.48",
          "mppr6064": "7.81",
          "mppr6569": "6.96",
          "mppr7074": "5.27",
          "mppr7599": "9.02"
        }
      }
    };
  }

  handleChange = (e) => {
    const name = e.target.name
    switch (name) {
      case 'y':
        this.setState({ y: e.target.value })
        return false;
      case 'x':
        this.setState({ x: e.target.value })
        return false;
      case 'geom':
        this.setState({ geom: e.target.value })
        return false;
      default:
        this.setState({ y: e.target.value })
        return false;
    }

  }

  clearInputs = () => {
    this.setState({
      y: '',
      x: '',
      geom: ''
    })
  }

  getData = () => {
    const { y, x, geom } = this.state;
    this.fetchAddress(y, x, geom)
  }

  fetchAddress = (y, x, geom) => {
    const url = 'https://api.locit.dev.beecommerce.pl/catchment_data';
    fetch(url, {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        y: parseFloat(y),
        x: parseFloat(x),
        geom: geom
      })
    })
      .then(response => response.json())
      .then(response => {
        const query = 'y=' + y + '&x=' + x + '&geom=' + geom;
        this.setState({
          curl: 'curl -X POST "http://locit.eu/webservice/catchment-data/v2.2.0/" -H "accept: application/json" -H "Content-Type: application/x-www-form-urlencoded" -d "' + query + '&format=json&charset=UTF-8"',
          code: response
        })
      })
  }

  render() {
    const { intl } = this.props
    const { y, x, geom, code, curl } = this.state
    return (
      <>
        <div className={styles.devDemo + ' row'}>
          <div className={'col-8 ' + styles.inputs}>
            <div className="row">
              <div className={isMobile ? "col-2 m0 " + styles.label : "col-2"}>
                <span>{intl.formatMessage({ id: 'demo3.dev.y_label' })}</span>
              </div>
              <div className={isMobile ? "col-10 m0" : "col-10 mb0"}>
                <label htmlFor="y">
                  {intl.formatMessage({ id: 'demo3.dev.y_desc' })}
                  <input type="text" name="y" value={y} onChange={this.handleChange} autoComplete="off" />
                </label>
              </div>
            </div>
            <div className="row">
              <div className={isMobile ? "col-2 m0 " + styles.label : "col-2"}>
                <span>{intl.formatMessage({ id: 'demo3.dev.x_label' })}</span>
              </div>
              <div className={isMobile ? "col-10 m0" : "col-10 mb0"}>
                <label htmlFor="x">
                  {intl.formatMessage({ id: 'demo3.dev.x_desc' })}
                  <input type="text" name="x" value={x} onChange={this.handleChange} autoComplete="off" />
                </label>
              </div>
            </div>
            <div className="row">
              <div className={isMobile ? "col-2 m0 " + styles.label : "col-2"}>
                <span>{intl.formatMessage({ id: 'demo3.dev.geom_label' })}</span>
              </div>
              <div className={isMobile ? "col-10 m0" : "col-10 mb0"}>
                <label htmlFor="geom">
                  {intl.formatMessage({ id: 'demo3.dev.geom_desc' })}
                  <input type="text" name="geom" value={geom} onChange={this.handleChange} autoComplete="off" />
                </label>
              </div>
            </div>
          </div>
          <div className={styles.buttons + ' col-5'}>
            {!isMobile ? <Button text={intl.formatMessage({ id: 'demo.dev.swagger' })} type="green" link="https://api.locit.io/docs/?urls.primaryName=catchment-data-v2.2.0" target="blank" /> : ''}
            <div className={styles.buttonsContainer}>
              <ActionButton text={intl.formatMessage({ id: 'button.send' })} type="blue" action={this.getData} />
              <ActionButton text={intl.formatMessage({ id: 'button.clear' })} type="transparent" action={this.clearInputs} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <p className={styles.responses}>{intl.formatMessage({ id: 'demo.dev.responses' })}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-1">
            <span>Curl</span>
          </div>
          <div className="col-11">
            <div className={styles.code}>
              <SyntaxHighlighter language="json" style={arta} customStyle={{ color: '#fff', padding: 15 }}>
                {curl}
              </SyntaxHighlighter>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-1">
            <span>{intl.formatMessage({ id: 'demo.dev.code' })}</span>
          </div>
          <div className="col-11">
            <div className={styles.code}>
              <SyntaxHighlighter language="json" style={arta} customStyle={{ color: '#fff', padding: 15 }}>
                {JSON.stringify(code, null, 2)}
              </SyntaxHighlighter>
            </div>
          </div>
        </div>
        {isMobile ? <div className="row">
          <div className="col-12"> <Button text={intl.formatMessage({ id: 'demo.dev.swagger' })} type="green" link="https://api.locit.io/docs/?urls.primaryName=catchment-data-v2.2.0" target="blank" /></div>
        </div> : ''}
      </>
    )
  }
}

export default compose(
  injectIntl
)(DemoDevCatchmentData)
